export interface Category {
  id: number;
  slug: string;
  name: string;
  description: string;
  icon: string;
  count: number;
}

export const categories: Category[] = [
  {
    id: 1,
    slug: "resource-navigation",
    name: "资源导航",
    description: "整合全网优质资源入口，涵盖设计、开发、运营等多个领域的一站式导航服务。",
    icon: "ri-compass-3-line",
    count: 1280,
  },
  {
    id: 2,
    slug: "tools-software",
    name: "工具软件",
    description: "精选各类效率工具与实用软件，覆盖办公、设计、开发、影音等全场景需求。",
    icon: "ri-tools-line",
    count: 960,
  },
  {
    id: 3,
    slug: "learning-tutorials",
    name: "学习教程",
    description: "汇集编程、设计、运营、职场等领域的优质学习资料与实战教程。",
    icon: "ri-book-open-line",
    count: 1560,
  },
  {
    id: 4,
    slug: "industry-news",
    name: "行业资讯",
    description: "追踪互联网行业最新动态，深度解读技术趋势与市场变化。",
    icon: "ri-newspaper-line",
    count: 2340,
  },
  {
    id: 5,
    slug: "member-services",
    name: "会员服务",
    description: "了解91网VIP会员专属权益，获取更专业、更全面的资源服务体验。",
    icon: "ri-vip-crown-line",
    count: 320,
  },
];